export const world = [
    {
        id: "content-world-global-trends",
        name: "Global trends",
        articles: [
            {
                id: "4da73fa5-c64a-43d8-873f-af7024fbae8c",
                class: "columns-3-balanced",
                header: "Africa",
                url: "#",
                image: {
                    src: "assets/images/will-shirley-xRKcHoCOA4Y-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Sed id semper risus in hendrerit gravida. Sagittis orci a scelerisque purus semper eget duis at tellus.",
                type: "text",
                content:
                    "Quam viverra orci sagittis eu volutpat odio facilisis mauris sit. Magna fringilla urna porttitor rhoncus dolor purus non enim praesent. Pellentesque sit amet porttitor eget dolor morbi non arcu risus. Dictum varius duis at consectetur. Ut porttitor leo a diam sollicitudin tempor id eu nisl.",
            },
            {
                id: "44d8807b-f06e-480f-8410-c5573127b527",
                class: "columns-3-balanced",
                header: "China",
                url: "#",
                image: {
                    src: "assets/images/nuno-alberto-MykFFC5zolE-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Convallis aenean et tortor at risus. Pellentesque elit eget gravida cum sociis natoque penatibus.",
                type: "text",
                content:
                    "Auctor urna nunc id cursus metus aliquam. Amet commodo nulla facilisi nullam. Blandit massa enim nec dui nunc mattis enim ut. Et netus et malesuada fames ac turpis. Pellentesque habitant morbi tristique senectus et netus et malesuada. Habitant morbi tristique senectus et netus et malesuada fames ace.",
            },
            {
                id: "56478e74-f501-45a5-b9db-5a41b049f32b",
                class: "columns-3-balanced",
                header: "Russia",
                url: "#",
                image: {
                    src: "assets/images/nikita-karimov-lvJZhHOIJJ4-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Pharetra magna ac placerat vestibulum lectus mauris ultrices eros.",
                type: "list",
                content: [
                    {
                        id: "8dd3d941-6b3f-4b3d-afd9-d7f8da8ead2b",
                        content: "Luctus venenatis lectus magna fringilla urna porttitor rhoncus.",
                    },
                    {
                        id: "139a317d-b2f2-433c-99ac-8d36df99d10e",
                        content: "Placerat orci nulla pellentesque dignissim enim sit amet venenatis.",
                    },
                    {
                        id: "74a84609-8f96-4ca3-8b1c-9e747ec9f260",
                        content: "Pellentesque nec nam aliquam sem et.",
                    },
                    {
                        id: "fba9be69-f42f-43dd-b930-1634edf7d79f",
                        content: "In hendrerit gravida rutrum quisque non tellus.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-around-the-world",
        name: "Around the world",
        articles: [
            {
                id: "22156cfb-5b44-4c70-adcc-8c560bb88bba",
                class: "columns-3-balanced",
                header: "Europe",
                image: {
                    src: "assets/images/azhar-j-t2hgHV1R7_g-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Porttitor massa id neque aliquam vestibulum. Semper auctor neque vitae tempus quam.",
                type: "text",
                content:
                    "Metus vulputate eu scelerisque felis imperdiet proin fermentum leo vel. Nisi scelerisque eu ultrices vitae auctor eu. Risus pretium quam vulputate dignissim suspendisse. Pulvinar neque laoreet suspendisse interdum. Mauris cursus mattis molestie a iaculis at erat.",
            },
            {
                id: "0e6692ed-3268-4442-a52d-16c37c16c5e2",
                class: "columns-3-balanced",
                header: "Middle East",
                image: {
                    src: "assets/images/adrian-dascal-myAz-buELXs-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Et molestie ac feugiat sed lectus vestibulum mattis.",
                type: "text",
                content: "Suspendisse interdum consectetur libero id faucibus nisl tincidunt eget nullam. Cursus vitae congue mauris rhoncus aenean vel elit scelerisque mauris. Quam vulputate dignissim suspendisse in est ante in nibh mauris.",
            },
            {
                id: "c9cd0674-b0de-4f53-9015-a97b57cf91d6",
                class: "columns-3-balanced",
                header: "Asia",
                image: {
                    src: "assets/images/mike-enerio-7ryPpZK1qV8-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Metus dictum at tempor commodo.",
                type: "list",
                content: [
                    {
                        id: "66e54612-a270-42eb-bbb0-139a318c45e9",
                        content: "Id faucibus nisl tincidunt eget nullam non nisi.",
                    },
                    {
                        id: "49682ded-80c4-4d15-a70d-051cf27b4657",
                        content: "Lectus quam id leo in vitae turpis massa.",
                    },
                    {
                        id: "e9c31e3a-6bfb-4c15-a2a2-a06ac315ac39",
                        content: "Urna nec tincidunt praesent semper feugiat nibh sed. Sed turpis tincidunt id aliquet risus.",
                    },
                    {
                        id: "3bdd19a2-3e3d-462e-a2f2-e65b1a78a0d3",
                        content: "Eu ultrices vitae auctor eu augue ut lectus.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-latest-media",
        name: "Latest Media",
        articles: [
            {
                id: "2c78e953-89f7-4a41-a852-6937b647674a",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "7a8ccd28-8a4d-44b4-aad4-b38b3f1ad734",
                        image: {
                            src: "assets/images/greg-rakozy-oMpAz-DN-9I-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "a571f7c4-c14f-420c-82fd-a90eea994817",
                        image: {
                            src: "assets/images/annie-spratt-KiOHnBkLQQU-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "8f35ff15-b931-4495-b4fa-784a7ac5f610",
                        image: {
                            src: "assets/images/noaa-Led9c1SSNFo-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "8c15911e-5185-4c46-9d66-3d7085226ce3",
                        image: {
                            src: "assets/images/paul-hanaoka-s0XabTAKvak-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-today",
        name: "Today",
        articles: [
            {
                id: "b4f53c23-c475-4359-9b73-84b5f193695e",
                class: "columns-3-wide",
                header: "Unrest",
                url: "#",
                image: {
                    src: "assets/images/venti-views-KElJx4R4Py8-unsplash_684.jpg",
                    alt: "Placeholder",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "Photo taken by someone.",
                    tag: {
                        type: "breaking",
                        label: "breaking",
                    },
                },
                title: "Viverra aliquet eget sit amet. In fermentum posuere urna nec.",
                type: "list",
                content: [
                    {
                        id: "7fb951cd-7360-4b0b-8eba-acc5682a72e2",
                        content: "Massa enim nec dui nunc mattis. Ornare lectus sit amet est placerat in.",
                    },
                    {
                        id: "cfc8cfb9-8775-4228-862d-3a4e974c8774",
                        content: "Morbi tristique senectus et netus et malesuada fames ac turpis.",
                    },
                    {
                        id: "3579af12-da1a-4126-90b1-fcdf15f13651",
                        content: "Fed vulputate mi sit amet mauris commodo quis imperdiet massa.",
                    },
                    {
                        id: "6da4806a-b188-4b7d-8bf1-7c73f2b192c1",
                        content: "In egestas erat imperdiet sed euismod nisi porta lorem mollis. Scelerisque eu ultrices vitae auctor eu augue ut lectus arcu.",
                    },
                ],
            },
            {
                id: "8e24c654-824d-4b80-add0-e6a69926e2e1",
                class: "columns-3-narrow",
                header: "Happening now",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "a9304ab1-83a0-4fd5-9ce7-1f09d5ed3ee3",
                        image: {
                            src: "assets/images/koshu-kunii-cWEGNQqcImk-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Semper auctor neque vitae tempus quam pellentesque nec nam aliquam.",
                    },
                    {
                        id: "0be2248d-d867-4676-8c29-2f7e9f44ef3d",
                        image: {
                            src: "assets/images/kenny-K72n3BHgHCg-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Viverra maecenas accumsan lacus vel facilisis volutpat.",
                    },
                    {
                        id: "0b0979bd-a6b6-4999-b981-e94e1af3e53d",
                        image: {
                            src: "assets/images/kitthitorn-chaiyuthapoom-TOH_gw5dd20-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Orci sagittis eu volutpat odio facilisis mauris sit.",
                    },
                ],
            },
            {
                id: "b838d62e-fc9b-4c7f-808b-dfe42ba8207b",
                class: "columns-3-narrow",
                header: "Noteworthy",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "4eca4918-9f65-467a-936a-2e3b70397d81",
                        image: {
                            src: "assets/images/olga-guryanova-tMFeatBSS4s-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nunc aliquet bibendum enim facilisis gravida neque convallis a.",
                    },
                    {
                        id: "92108745-e25b-4ee4-a725-81298d1aee29",
                        image: {
                            src: "assets/images/jed-owen-ajZibDGpPew-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Ut diam quam nulla porttitor massa id neque aliquam vestibulum.",
                    },
                    {
                        id: "0f037b8a-f7ee-4b05-a8b2-4801469f11d4",
                        image: {
                            src: "assets/images/noaa-FY3vXNBl1v4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Magna fermentum iaculis eu non diam phasellus vestibulum lorem.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-featured",
        name: "Featured",
        articles: [
            {
                id: "333174c6-e4f4-4376-b0ff-38d31161b9db",
                class: "columns-3-balanced",
                header: "European Union",
                image: {
                    src: "assets/images/christian-lue-8Yw6tsB8tnc-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Luctus venenatis lectus magna fringilla urna.",
                type: "list",
                content: [
                    {
                        id: "53bc47b0-879f-41c5-90d2-f17ecd997277",
                        content: "Nulla facilisi cras fermentum odio eu. Porttitor lacus luctus accumsan tortor posuere ac ut.",
                    },
                    {
                        id: "560c1c79-adfe-4dc3-9481-3f6eeee479e2",
                        content: "Phasellus egestas tellus rutrum tellus pellentesque eu tincidunt. Leo vel orci porta non. Sem nulla pharetra diam sit amet nisl.",
                    },
                    {
                        id: "7356169a-a957-4212-a4d0-de79817fad66",
                        content: "Justo donec enim diam vulputate ut pharetra sit amet aliquam. Eu consequat ac felis donec et.",
                    },
                ],
            },
            {
                id: "28fd8202-0588-42a2-bb92-54c534521b23",
                class: "columns-3-balanced",
                header: "Britain",
                image: {
                    src: "assets/images/ian-taylor-kAWTCt7p7rs-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Orci a scelerisque purus semper eget duis.",
                type: "text",
                content:
                    "Gravida rutrum quisque non tellus orci ac auctor augue mauris. Enim ut sem viverra aliquet eget. Sit amet volutpat consequat mauris nunc congue nisi vitae.\n\nPraesent tristique magna sit amet purus gravida quis blandit turpis. Commodo odio aenean sed adipiscing diam donec adipiscing tristique risus. Quam quisque id diam vel quam elementum.",
            },
            {
                id: "bcb67523-c31c-44ae-b9a1-a2b3b0cc5793",
                class: "columns-3-balanced",
                header: "Latin America",
                image: {
                    src: "assets/images/axp-photography-v6pAkO31d50-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Congue nisi vitae suscipit tellus.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "bd2b0d68-f13e-4e22-83e9-e930ca8aa68b",
                        content: "Ut venenatis tellus in metus vulputate.",
                        url: "#",
                    },
                    {
                        id: "616a45c1-6d95-41f0-b1c1-d64dc56c0eb5",
                        content: "Vitae aliquet nec ullamcorper sit amet risus nullam.",
                        url: "#",
                    },
                    {
                        id: "064361e4-4ba5-4113-8276-bd34ac0fd180",
                        content: "Ellus in hac habitasse platea dictumst.",
                        url: "#",
                    },
                    {
                        id: "3f865ca0-fc2b-48c2-aaf0-9804d375d97c",
                        content: "In nisl nisi scelerisque eu ultrices vitae.",
                        url: "#",
                    },
                    {
                        id: "20cd0523-4256-4950-b934-e6bb73423246",
                        content: "Est ullamcorper eget nulla facilisi etiam dignissim diam quis enim.",
                        url: "#",
                    },
                    {
                        id: "a823ac1f-f1d0-4a52-a5ca-d02edeba7156",
                        content: "It volutpat diam ut venenatis tellus.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-international",
        name: "International",
        articles: [
            {
                id: "bcdb2555-6ea9-48cc-b99e-7c496e95b54a",
                class: "columns-wrap",
                header: "United Nations",
                type: "excerpt",
                content: [
                    {
                        id: "99ce4c22-46fb-4137-81fd-567ebea802d2",
                        image: {
                            src: "assets/images/ilyass-seddoug-06w8RxgSzF0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Morbi quis commodo odio aenean sed adipiscing diam. Congue mauris rhoncus aenean vel elit scelerisque mauris pellentesque. Justo nec ultrices dui sapien.",
                    },
                    {
                        id: "abb17f65-6190-4f97-805b-8bf8f7adb5aa",
                        image: {
                            src: "assets/images/mathias-reding-yfXhqAW5X0c-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nibh nisl condimentum id venenatis a condimentum. Id diam maecenas ultricies mi eget mauris pharetra et ultrices. Faucibus turpis in eu mi bibendum neque egestas. Et malesuada fames ac turpis egestas sed tempus urna et.",
                    },
                    {
                        id: "21309be8-782a-4417-b312-c8e110643d57",
                        image: {
                            src: "assets/images/matthew-tenbruggencate-0HJWobhGhJs-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ut etiam sit amet nisl purus in mollis nunc sed. Pellentesque adipiscing commodo elit at imperdiet dui. Ac tortor vitae purus faucibus ornare suspendisse sed nisi lacus. Enim facilisis gravida neque convallis.",
                    },
                ],
            },
            {
                id: "db9bc4e6-b7d8-4cbd-b9a6-17bc5c50b8b1",
                class: "columns-wrap",
                header: "European Union",
                type: "excerpt",
                content: [
                    {
                        id: "79697e7e-9dae-4f38-b49d-42d95177873f",
                        image: {
                            src: "assets/images/markus-spiske-wIUxLHndcLw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Donec massa sapien faucibus et molestie. Fermentum iaculis eu non diam. Donec pretium vulputate sapien nec sagittis. Placerat duis ultricies lacus sed. Pretium lectus quam id leo in vitae turpis massa.",
                    },
                    {
                        id: "94ebd599-031c-4a39-8ee8-e0e6bfefcb3a",
                        image: {
                            src: "assets/images/jakub-zerdzicki-VnTR3XFwxWs-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Luctus accumsan tortor posuere ac ut. Convallis posuere morbi leo urna molestie at elementum. Nisi est sit amet facilisis magna etiam tempor orci eu.",
                    },
                    {
                        id: "01420c0f-c015-46b3-8a3d-1d189ca449ba",
                        image: {
                            src: "assets/images/guillaume-perigois-HL4LEIyGEYU-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Purus in massa tempor nec feugiat nisl pretium fusce. Fermentum odio eu feugiat pretium nibh ipsum consequat nisl vel. Vestibulum sed arcu non odio euismod lacinia at quis.",
                    },
                ],
            },
            {
                id: "a4208fe3-e9b4-46f6-af7e-ff04522ccc9c",
                class: "columns-wrap",
                header: "Global Crisis",
                type: "excerpt",
                content: [
                    {
                        id: "9c0c4297-c959-4b66-b691-14227aa9ff6c",
                        image: {
                            src: "assets/images/mika-baumeister-jXPQY1em3Ew-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "ristique senectus et netus et malesuada. Orci phasellus egestas tellus rutrum tellus pellentesque eu tincidunt. Varius quam quisque id diam vel quam elementum pulvinar. Quis imperdiet massa tincidunt nunc pulvinar sapien et ligula.",
                    },
                    {
                        id: "aa8c49f6-2479-48a9-b0f4-ab66d088335b",
                        image: {
                            src: "assets/images/chris-leboutillier-c7RWVGL8lPA-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Cras ornare arcu dui vivamus arcu felis bibendum ut. Volutpat blandit aliquam etiam erat velit scelerisque in dictum. Pharetra magna ac placerat vestibulum lectus.",
                    },
                    {
                        id: "fc48d069-7cb3-4a59-9a33-76a8baecbfcc",
                        image: {
                            src: "assets/images/mulyadi-JeCNRxGLSp4-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Leo integer malesuada nunc vel. Porttitor lacus luctus accumsan tortor posuere ac ut consequat. Ultrices eros in cursus turpis massa tincidunt dui ut. Eleifend mi in nulla posuere sollicitudin.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-global-impact",
        name: "Global Impact",
        articles: [
            {
                id: "48ae1b0c-4f0c-47f8-ab31-4ec18aaaf24c",
                class: "columns-3-balanced",
                header: "Weather",
                image: {
                    src: "assets/images/noaa-I323ZqSkkn8-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Euismod elementum nisi quis eleifend.",
                type: "list",
                content: [
                    {
                        id: "435c2c23-3643-4494-bc44-0d6f83c5fd9f",
                        content: "Enim tortor at auctor urna nunc id cursus metus. Nisi est sit amet facilisis magna etiam.",
                    },
                    {
                        id: "9544aa73-f54a-4983-8e7f-71fd06dbb9d8",
                        content: "Neque volutpat ac tincidunt vitae. Metus aliquam eleifend mi in.",
                    },
                    {
                        id: "160354ef-50d3-40ed-a9c7-7eac7e9c08ce",
                        content: "Aliquam malesuada bibendum arcu vitae elementum curabitur vitae.",
                    },
                    {
                        id: "08f7738e-72c2-48e5-9f38-bbf2990a7134",
                        content: "Turpis cursus in hac habitasse platea dictumst.",
                    },
                ],
            },
            {
                id: "71a55a05-6c7a-432e-8d8f-dc55746911e6",
                class: "columns-3-balanced",
                header: "Business",
                image: {
                    src: "assets/images/david-vives-Nzbkev7SQTg-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nunc mi ipsum faucibus vitae aliquet nec ullamcorper.",
                type: "list",
                content: [
                    {
                        id: "e194840d-555d-4a68-be98-25550267e1d9",
                        content: "Eget nulla facilisi etiam dignissim diam quis enim.",
                    },
                    {
                        id: "35ddcd29-6018-422a-b7c9-0b365fef1a4a",
                        content: "Risus viverra adipiscing at in tellus integer feugiat scelerisque.",
                    },
                    {
                        id: "0efb298b-269b-4ef0-8933-6a9270d394f0",
                        content: "Cursus turpis massa tincidunt dui.",
                    },
                    {
                        id: "8b25917a-5242-4266-a57b-ef73e6b31164",
                        content: "Nascetur ridiculus mus mauris vitae ultricies leo integer.",
                    },
                ],
            },
            {
                id: "f44f022b-f57e-4d6d-84bc-904dfad9686a",
                class: "columns-3-balanced",
                header: "Politics",
                image: {
                    src: "assets/images/kelli-dougal-vbiQ_7vwfrs-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Vulputate sapien nec sagittis aliquam malesuada.",
                type: "list",
                content: [
                    {
                        id: "8d525dd3-f1e0-4f5a-9c7a-87bd07fea873",
                        content: "Nisi scelerisque eu ultrices vitae auctor.",
                    },
                    {
                        id: "7189799f-3051-4db0-990b-4473999e7450",
                        content: "Urna porttitor rhoncus dolor purus non enim praesent elementum.",
                    },
                    {
                        id: "a7ecada6-4c11-4c8e-bf88-b43f20be9a56",
                        content: "Ac turpis egestas integer eget aliquet.",
                    },
                    {
                        id: "0db12cd0-cbb1-47eb-8cae-2962fdcb3f40",
                        content: "Nisl tincidunt eget nullam non nisi est.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-underscored",
        name: "Underscored",
        articles: [
            {
                id: "060bbae5-655f-4ed6-ae0f-8afdb2056ecf",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "60ba264f-7a61-46eb-b3de-d49fa763c764",
                        image: {
                            src: "assets/images/luis-cortes-QrPDA15pRkM-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Risus sed vulputate odio ut enim blandit volutpat. Tempus egestas sed sed risus pretium quam vulputate. Ultrices mi tempus imperdiet nulla malesuada. Pellentesque diam volutpat commodo sed egestas. Scelerisque eleifend donec pretium vulputate sapien nec sagittis aliquam.",
                        url: "#",
                    },
                    {
                        id: "d373cfad-4871-4de4-9a92-c075975c08e6",
                        image: {
                            src: "assets/images/juli-kosolapova-4PE3X9eKsu4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Nunc mi ipsum faucibus vitae aliquet nec. Felis eget nunc lobortis mattis aliquam faucibus. Amet est placerat in egestas. Vitae proin sagittis nisl rhoncus mattis rhoncus. Mauris in aliquam sem fringilla ut. Pellentesque habitant morbi tristique senectus et netus et.",
                        url: "#",
                    },
                ],
            },
            {
                id: "b4ef9c47-027a-4870-8413-b83366e1ce21",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "cc15c9f6-f311-4cfb-b303-d89d07821c57",
                        image: {
                            src: "assets/images/olga-guryanova-ft7vJxwl2RY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Egestas diam in arcu cursus euismod quis viverra nibh cras. Scelerisque fermentum dui faucibus in ornare quam viverra orci sagittis. Sed ullamcorper morbi tincidunt ornare massa eget egestas purus viverra. Risus in hendrerit gravida rutrum.",
                        url: "#",
                    },
                    {
                        id: "afe1b73f-e6a1-4efd-94f7-2df513a47e33",
                        image: {
                            src: "assets/images/christian-tenguan-P3gfVKhz8d0-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Integer malesuada nunc vel risus commodo viverra maecenas accumsan. Nec feugiat nisl pretium fusce id. Vel fringilla est ullamcorper eget nulla facilisi etiam dignissim diam. At tempor commodo ullamcorper a lacus vestibulum sed arcu. Suspendisse faucibus interdum posuere lorem ipsum dolor.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-global-issues",
        name: "Global Issues",
        articles: [
            {
                id: "f189aeb3-f002-4cf4-929e-1957c1e049a9",
                class: "columns-wrap",
                header: "Rising Crime",
                type: "excerpt",
                content: [
                    {
                        id: "4b6aab59-4f86-48df-ae8b-be102859aa43",
                        image: {
                            src: "assets/images/martin-podsiad-wrdtA9lew9E-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Phasellus faucibus scelerisque eleifend donec pretium. Tellus molestie nunc non blandit. Sed sed risus pretium quam vulputate dignissim suspendisse.",
                    },
                    {
                        id: "4d133373-3f3e-4747-a6c0-62c0435659a4",
                        image: {
                            src: "assets/images/valtteri-laukkanen-9u9Pc0t9vKM-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "In vitae turpis massa sed. In hac habitasse platea dictumst vestibulum rhoncus est pellentesque elit. Egestas pretium aenean pharetra magna ac placerat vestibulum.",
                    },
                    {
                        id: "f409ea51-7607-4654-883e-26c93eaab5f0",
                        image: {
                            src: "assets/images/alec-favale-dLctr-PqFys-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Morbi tempus iaculis urna id volutpat lacus laoreet non. Dignissim convallis aenean et tortor at risus viverra adipiscing at. Nibh tortor id aliquet lectus proin nibh nisl.",
                    },
                ],
            },
            {
                id: "ddf4293b-3356-4ec4-b349-75d29690623e",
                class: "columns-wrap",
                header: "Health concerns",
                type: "excerpt",
                content: [
                    {
                        id: "6cb27761-d3d4-4641-9fc6-e6cab0b10f78",
                        image: {
                            src: "assets/images/ani-kolleshi-7jjnJ-QA9fY-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Id diam maecenas ultricies mi eget mauris pharetra. Aliquam sem fringilla ut morbi tincidunt augue interdum. Accumsan sit amet nulla facilisi morbi tempus iaculis.",
                    },
                    {
                        id: "43fc66f4-5f79-499d-80e0-a57f9ed08623",
                        image: {
                            src: "assets/images/piron-guillaume-U4FyCp3-KzY-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "In fermentum posuere urna nec tincidunt praesent semper feugiat nibh. Dolor sit amet consectetur adipiscing elit pellentesque habitant. Eget dolor morbi non arcu risus quis varius quam quisque.",
                    },
                    {
                        id: "6d0f9b0c-a0b8-4f2a-8797-49525361253f",
                        image: {
                            src: "assets/images/hush-naidoo-jade-photography-ZCO_5Y29s8k-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Commodo sed egestas egestas fringilla phasellus faucibus. Lectus urna duis convallis convallis. Sit amet tellus cras adipiscing enim eu turpis egestas.",
                    },
                ],
            },
            {
                id: "9b501227-b127-49b2-80d6-33945e5ea16c",
                class: "columns-wrap",
                header: "Economy",
                type: "excerpt",
                content: [
                    {
                        id: "f8e005ef-0704-4406-86c0-4a9bd6a15850",
                        image: {
                            src: "assets/images/ibrahim-rifath-OApHds2yEGQ-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ante in nibh mauris cursus mattis molestie. Vestibulum sed arcu non odio euismod lacinia at quis. Consequat semper viverra nam libero justo laoreet.",
                    },
                    {
                        id: "56d43b99-481c-4194-a822-cf9d9973eef9",
                        image: {
                            src: "assets/images/mika-baumeister-bGZZBDvh8s4-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nunc non blandit massa enim nec dui nunc. Lobortis feugiat vivamus at augue eget arcu. Tempor commodo ullamcorper a lacus. Malesuada bibendum arcu vitae elementum curabitur vitae.",
                    },
                    {
                        id: "9a1e8128-7d8e-4eb2-a285-e15c1b7c302c",
                        image: {
                            src: "assets/images/shubham-dhage-tT6GNIFkZv4-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "In nulla posuere sollicitudin aliquam ultrices sagittis orci a. Sem fringilla ut morbi tincidunt augue interdum. Arcu felis bibendum ut tristique et egestas. Praesent elementum facilisis leo vel fringilla est ullamcorper.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-hot-topics",
        name: "Hot Topics",
        articles: [
            {
                id: "2ecc66a8-422a-4ec1-8523-b2b3b6bd95d1",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "0d4def92-1511-4113-892c-53a8432447f2",
                        image: {
                            src: "assets/images/dino-reichmuth-A5rCN8626Ck-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Leo vel fringilla est ullamcorper eget nulla facilisi etiam dignissim. Aliquam nulla facilisi cras fermentum odio. In est ante in nibh. Vulputate ut pharetra sit amet aliquam. Vitae congue eu consequat ac felis. Semper auctor neque vitae tempus quam pellentesque nec nam aliquam.",
                        url: "#",
                    },
                    {
                        id: "af24d79c-6907-48b6-90a7-beb337072c56",
                        image: {
                            src: "assets/images/ross-parmly-rf6ywHVkrlY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Vitae sapien pellentesque habitant morbi tristique senectus. Faucibus interdum posuere lorem ipsum dolor sit. Urna id volutpat lacus laoreet non curabitur. Tristique et egestas quis ipsum suspendisse ultrices gravida dictum.",
                        url: "#",
                    },
                ],
            },
            {
                id: "e97c9e59-bce0-408e-8151-644b4c51fa24",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "e6e33328-8fdd-4e03-8226-32b43f3d9523",
                        image: {
                            src: "assets/images/caglar-oskay-d0Be8Vs9XRk-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Donec ultrices tincidunt arcu non sodales neque sodales ut. Consequat mauris nunc congue nisi vitae suscipit tellus mauris. Dictum sit amet justo donec enim diam vulputate. Ultrices vitae auctor eu augue ut lectus arcu bibendum at.",
                        url: "#",
                    },
                    {
                        id: "32013b56-f744-46f7-b608-5081c4917db9",
                        image: {
                            src: "assets/images/oguzhan-edman-ZWPkHLRu3_4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Consectetur adipiscing elit pellentesque habitant morbi tristique senectus et. Adipiscing at in tellus integer feugiat scelerisque varius. Faucibus ornare suspendisse sed nisi lacus sed viverra tellus in. Eget velit aliquet sagittis id consectetur purus ut faucibus pulvinar.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-paid-content",
        name: "Paid Content",
        articles: [
            {
                id: "6f02bb8e-b794-403e-8417-6efaf23f7d4f",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "22d0366d-8577-4f16-93ec-8058cab99d5f",
                        image: {
                            src: "assets/images/jakub-zerdzicki-qcRGVZNZ5js-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Et sollicitudin ac orci phasellus. Massa placerat duis ultricies lacus sed turpis tincidunt id.",
                    },
                ],
            },
            {
                id: "c1ab91c2-8a27-4b86-b862-f2cb98d99636",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "db656467-45dd-49c2-9761-97bf666b6c4f",
                        image: {
                            src: "assets/images/arnel-hasanovic-MNd-Rka1o0Q-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Neque volutpat ac tincidunt vitae semper. Nunc pulvinar sapien et ligula. Quam pellentesque nec nam aliquam sem et tortor consequat.",
                    },
                ],
            },
            {
                id: "ea11fca8-afd0-4aab-b106-047aab8ca678",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "d888984a-bf15-4c07-a3d7-28fb93496d06",
                        image: {
                            src: "assets/images/ilaria-de-bona-RuFfpBsaRY0-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Velit euismod in pellentesque massa placerat duis ultricies. Nulla aliquet enim tortor at auctor. Vitae et leo duis ut diam quam nulla porttitor massa.",
                    },
                ],
            },
            {
                id: "44a282f4-379a-41bd-bccb-5d7a16aa8d98",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "4a073a92-8e03-4dec-9c8f-47f1f5c72ef9",
                        image: {
                            src: "assets/images/k8-uYf_C34PAao-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Eros in cursus turpis massa tincidunt dui ut ornare lectus. Pulvinar neque laoreet suspendisse interdum consectetur libero id faucibus nisl.",
                    },
                ],
            },
        ],
    },
];
